/**
 * Simple Key Enumeration
 */
export const enum KeyboardKey {
    Unknown,
    Tab,
    Enter,
    Escape,
    ArrowUp,
    ArrowDown,
    Shift = 16,
    Space = 32,
    Zero = 48,
    Nine = 57,
    A = 65,
    Z = 90,
    Slash = 191
}

/**
 * This is a helper class that handles distinguishing keystrokes
 */
export class KeystrokeHandler {

    private static readonly KeysToKeyboardKeys: { [key: string]: KeyboardKey } = {
        'Tab': KeyboardKey.Tab,
        'Enter': KeyboardKey.Enter,
        'Shift': KeyboardKey.Shift,
        'Esc': KeyboardKey.Escape,
        'Escape': KeyboardKey.Escape,
        'Up': KeyboardKey.ArrowUp,
        'ArrowUp': KeyboardKey.ArrowUp,
        'Down': KeyboardKey.ArrowDown,
        'ArrowDown': KeyboardKey.ArrowDown,
        'Spacebar': KeyboardKey.Space, // Backward compatibility for IE 11
        ' ': KeyboardKey.Space,
        'Zero': KeyboardKey.Zero,
        'Nine': KeyboardKey.Nine,
        'a': KeyboardKey.A,
        'z': KeyboardKey.Z,
        'A': KeyboardKey.A,
        'Z': KeyboardKey.Z,
        '/': KeyboardKey.Slash
    };

    private static readonly KeyCodesToKeyboardKeys: { [keyCode: number]: KeyboardKey } = {
        9: KeyboardKey.Tab,
        13: KeyboardKey.Enter,
        16: KeyboardKey.Shift,
        27: KeyboardKey.Escape,
        32: KeyboardKey.Space,
        38: KeyboardKey.ArrowUp,
        40: KeyboardKey.ArrowDown,
        48: KeyboardKey.Zero,
        57: KeyboardKey.Nine,
        65: KeyboardKey.A,
        90: KeyboardKey.Z,
        191: KeyboardKey.Slash
    };

    /**
     * Returns the key represented by the given event
     *
     * @param {KeyboardEvent} value - This is the KeyboardEvent representing a keystroke
     * @return {KeyboardKey} - The key that was pressed, or unknown
     */
    public static getKey(event: KeyboardEvent): KeyboardKey {
        return KeystrokeHandler.KeysToKeyboardKeys[event.key] || KeystrokeHandler.KeyCodesToKeyboardKeys[event.keyCode] || KeyboardKey.Unknown;
    }
}
